import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { AppService } from './app.service';

@Injectable({ providedIn: 'root' })
export class ExternalDocumentService extends AppService {
  constructor(
    public http: HttpClient,
    @Inject('environment') environment: any
  ) {
    super(http, environment);
  }

  uploadDocument(id: number, formData: any) {
    var userId = this.getUser().userId;
    const url = this.getEndpoint(
            `ExemptionFilingRequestBasic/${id}/Document`
          );

    const req = new HttpRequest('POST', url, formData, {
        reportProgress: true,
        responseType: 'json',
        headers: this.gethttpOptionsFormDataContent()
      });
      return this.http.request(req);
  }

  getDocuments(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestDetail/${id}/Documents`),
      this.gethttpOptions()
    );
  }
}
